<template>
  <div>
    <!-- Pay -->
    <a-modal v-model="visible" title="Pay student fee" onOk="handleOk"
      :width="this.settings['isMobileView'] ? 360 : this.settings['isTabletView'] ? 560 : 720"
      :destroyOnClose="true"
    >
      <template slot="footer">
          <a-button key="back" @click="handleCancel">Cancel</a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handlePay">Pay Fee</a-button>
      </template>
      <a-spin :spinning="spinning">
        <div v-if="studentFeeData">
          <p class="font-weight-bold mb-2 text-muted">Fee details:</p>
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Fee</th>
                <th>Amount</th>
                <th>Fine</th>
                <th>Dis.</th>
                <th>Dis. %</th>
                <th>Due</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>{{studentFeeData.fee_setting.class_fee ? studentFeeData.fee_setting.class_fee.fee.name : studentFeeData.fee_setting.fee.name}}</th>
                <td>₹ {{studentFeeData.amount}}</td>
                <td>₹ {{studentFeeData.fine ? studentFeeData.fine : 0}}</td>
                <td>₹ {{studentFeeData.discount_amount ? studentFeeData.discount_amount : 0}}</td>
                <td>{{studentFeeData.discount_percentage ? studentFeeData.discount_percentage : 0}}%</td>
                <td>₹ {{studentFeeData.due_amount}}</td>
                <td>₹ {{studentFeeData.fee_total}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <hr class="mt-2 mb-4">

        <a-form class="mb-0" :form="form" @submit="handlePay">
          <div class="row mb-0">
            <div class="col-md-4 mb-2">
              <a-form-item class="mb-0" label="Fine Amount">
                <div style="width:120px;">
                  <a-input-number
                    placeholder="Fine"
                    v-decorator="[`fine`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                    :min="0"
                    :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                    style="width:100%;"
                  />
                </div>
              </a-form-item>
            </div>
            <div class="col-md-4 mb-2">
              <a-form-item label="Discount Type">
                <a-select style="width:150px" v-model="discountType">
                  <a-select-option value="amount">Amount</a-select-option>
                  <a-select-option value="percentage">Percentage</a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-4 mb-2" v-if="discountType === 'amount'">
              <a-form-item class="mb-0" label="Discount Amount">
                <div style="width:120px;">
                  <a-input-number
                    placeholder="Discount amount"
                    v-decorator="[`discount_amount`, {rules: [{ required: false, message: 'Please input fee amount!' }]}]"
                    :min="0"
                    :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                    style="width:100%;"
                  />
                </div>
              </a-form-item>
            </div>
            <div class="col-md-4 mb-2" v-if="discountType === 'percentage'">
              <a-form-item class="mb-0" label="Discount Percentage">
                <div style="width:120px;">
                  <a-input-number
                    placeholder="Discount %"
                    v-decorator="[`discount_percentage`, {rules: [{ required: false, message: 'Please input fee amount!' }] }]"
                    :min="0"
                    :max="100"
                    :formatter="value => `${value}%`"
                    :parser="value => value.replace(/\%\s?|(,*)/g, '')"
                    style="width:100%;"
                  />
                </div>
              </a-form-item>
            </div>
            <div class="col-md-6 mb-2">
              <div class="row">
                <div class="col-8 col-sm-6">
                  <a-form-item class="mb-0" label="Paid Amount">
                    <div style="width:150px;">
                      <a-input-number
                        placeholder="Amount"
                        v-decorator="[`paid_amount`, {rules: [{ required: true, message: 'Please input an amount!' }],initialValue: getPayableFee(
                              studentFeeData,
                              form.getFieldValue('fine'),
                              form.getFieldValue('discount_amount'),
                              form.getFieldValue('discount_percentage')
                            ) }]"
                        :min="0"
                        :formatter="value => `₹ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\₹\s?|(,*)/g, '')"
                        :disabled="true"
                        style="width:100%;"
                      />
                    </div>
                  </a-form-item>
                </div>
                <!-- Payable pee -->
                <div class="col-4 col-sm-6 mt-2">
                  <p class="mt-4 mb-0 font-weight-bold text-danger" v-if="studentFeeData && discountType">
                    / ₹{{getPayableFee(
                      studentFeeData,
                      form.getFieldValue('fine'),
                      form.getFieldValue('discount_amount'),
                      form.getFieldValue('discount_percentage'),
                      )}}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 mb-2">
              <a-form-item
                label="Payment Mode"
              >
                <a-select
                  v-decorator="[
                    'payment_type',
                    {rules: [{ required: true, message: 'Please select a payment type!!' }],
                    initialValue: 0 }
                  ]"
                  placeholder="Select payment type"
                >
                  <a-select-option v-for="paymentType in paymentTypes" :value="paymentType.value" :key="paymentType.value">
                  {{paymentType.name}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
            <div class="col-md-6 mb-2">
              <a-form-item label="Paid by">
                <a-input
                  placeholder="Full Name"
                  v-decorator="['paid_by', {rules: [{ required: true, message: 'Please input a name!' }]}]"
                />
              </a-form-item>
            </div>
            <div class="col-md-6 mb-2">
              <a-form-item
                label="Payment Date"
              >
              <a-date-picker
                @change="handlePaymentDateChange"
                v-decorator="[
                'payment_date',
                {rules: [{ required: true, message: 'Please input a date' }], initialValue: moment()},
                ]"
                :format=dateFormat />
              </a-form-item>
            </div>
            <div class="col-md-12 mb-2">
              <a-form-item label="Remark">
                <a-input
                  placeholder="Payment remark"
                  v-decorator="['remark', {rules: [{ required: false, message: 'Please input a remark!' }]}]"
                />
              </a-form-item>
            </div>
          </div>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

import { paymentTypes } from '@/services/globaldata'

export default {
  name: 'PayStudentFee',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      dateFormat: 'DD-MM-YYYY',
      classFees: null,
      feesLoading: false,
      studentFeeId: null,
      studentFeeData: null,
      discountType: 'amount',
      paymentTypes,
      feeTotal: 0,
      studentId: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openStudentFeePayModal', this.showModal)
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    moment,
    showModal: function(data) {
      let studentFee = data[0]
      this.studentId = data[1]
      this.studentFeeId = studentFee.id
      this.studentFeeData = studentFee
      this.visible = true
      // this.spinning = true
      // if (studentFee.discount_percentage) {
      //   this.discountType = 'percentage'
      // } else {
      //   this.discountType = 'amount'
      // }
      // this.$nextTick(function() {
      //   const fieldsData = this.makeFeeData(studentFee)
      //   this.form.setFieldsValue(fieldsData)
      // })
    },
    handlePay: function (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the Pay button to pay the fee!`,
            okText: 'Pay',
            onOk: () => {
              const formData = this.makeEditFormData(values)
              this.$http
                .post('/api/student_fee/pay/' + this.studentFeeId, formData)
                .then(({ data }) => {
                  this.$emit('paid')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully paid',
                    description: `Student fees paid successfully!`,
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    makeFeeData: function(studentFee) {
      const fieldData = {
        fine: studentFee.fine,
        discount_amount: 0,
        discount_percentage: 0,
      }
      if (studentFee.discount_percentage) {
        fieldData.discount_percentage = studentFee.discount_percentage
      } else {
        fieldData.discount_amount = studentFee.discount_amount
      }
      return fieldData
    },
    makeEditFormData(values) {
      let data = {
        payment_date: moment(values.payment_date).format('YYYY-MM-DD'),
        paid_by: values.paid_by,
        remark: values.remark,
        fine: values.fine ? values.fine : 0,
        payment_type: values.payment_type,
        paid_amount: values.paid_amount,
        student_id: this.studentId,
        is_paid_by_school: 1,

      }

      if (this.discountType === 'amount') {
        data.discount_amount = values.discount_amount ? values.discount_amount : 0
        data.discount_percentage = 0
      }
      if (this.discountType === 'percentage') {
        data.discount_amount = 0
        data.discount_percentage = values.discount_percentage ? values.discount_percentage : 0
      }
      return data
    },
    handleFeeChange(feeId) {
      const fee = find(this.classFees, { id: feeId })
      if (fee) {
        this.form.setFieldsValue({ fee_amount: fee.fee_amount })
      } else {
        this.form.setFieldsValue({ fee_amount: 0 })
      }
    },
    getPayableFee(studentFee, fine, discountAmount, discountPercentage) {
      let amount = studentFee.amount
      let totalAmount = studentFee.fee_total
      let discount = 0
      if (this.discountType === 'amount') {
        discount = discountAmount || 0
      }
      if (this.discountType === 'percentage') {
        discount = amount * (discountPercentage * 0.01) || 0
      }
      console.log('amount:: ', amount)
      console.log('discount:: ', discount)
      console.log('totalAmount:: ', totalAmount)
      fine = fine || 0
      return (totalAmount + fine - discount).toFixed(2)
    },
    handlePaymentDateChange: function (value) {
      this.loading = true
      this.spinning = true
      let oldStudentFeeData = this.studentFeeData
      this.$http
        .get('/api/student_fee_calculated', {
          params: {
            payment_date: moment(value).format('YYYY-MM-DD'),
            student_fee_ids: [oldStudentFeeData.id],
            is_paid_by_school: 1,
          },
        })
        .then(({ data }) => {
          // this.form.setFieldsValue('')
          this.studentFeeData = data.student_fees[0]
          this.loading = false
          this.spinning = false
        })
        .catch(error => {
          this.spinning = false
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
  },
}
</script>
